import { getApiInstance } from '../api';

export const deleteProposal = async ({
  token,
  proposalId,
}: {
  token: string;
  proposalId: string;
}) => {
  const api = getApiInstance(token);
  try {
    await api.delete(`/proposals/${proposalId}`);

    return { success: true };
  } catch (error) {
    console.error(error);
    return {
      success: false,
      message: `Erro ao deletar proposta. ${(error as Error).message}`,
    };
  }
};
